import React from 'react'
import PropTypes from 'prop-types'

import Toggle from 'react-toggle'

import './ToggleButton.sass'

const ToggleButton = ({checked, onChange}) => {

  return (
    <Toggle
      icons={false}
      checked={checked}
      onChange={onChange}
    />
  )
}

ToggleButton.defaultProps = {
  checked: true,
  onChange: () => {},
}

ToggleButton.propTypes = {
  checked: PropTypes.bool,
  onChange: PropTypes.func
}

export default ToggleButton
